
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sections/[id]",
      function () {
        return require("private-next-pages/sections/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sections/[id]"])
      });
    }
  